import {
  FormElement,
  FormElementType,
} from "@kolibrisoftware/customerportal-api";
import { FC, useMemo } from "react";
import FormPartElement from "modules/questionnaire/components/form-part";
import FormSectionElement from "../../components/form-section";
import FormQuestionElement from "../../components/form-question";
import FormText from "modules/questionnaire/components/form-text";

type Props = {
  elementStructure: FormElement;
  hierarchyLevel: number;
  elementIndex?: number;
  totalSiblings?: number;
};

const FormElementWrapper: FC<Props> = ({
  elementStructure,
  hierarchyLevel,
  elementIndex,
  totalSiblings,
}) => {
  const elementChildrenElements = useMemo(() => {
    const elementChildren = elementStructure.elements || [];
    const filteredElements = elementChildren.filter(
      child =>
        child.type !== FormElementType.Section ||
        child.elements?.length ||
        child.customQuestions?.length
    );

    const totalSiblings = filteredElements.filter(
      child => child.useIndex
    ).length;

    let elementIndex = 0;

    return filteredElements.map(child => (
      <FormElementWrapper
        elementStructure={child}
        hierarchyLevel={hierarchyLevel + 1}
        elementIndex={child.useIndex ? elementIndex++ : undefined}
        totalSiblings={totalSiblings}
        key={child.id}
      />
    ));
  }, [elementStructure, hierarchyLevel]);

  const currentElement = useMemo(() => {
    switch (elementStructure.type) {
      case FormElementType.Part:
        return (
          <FormPartElement
            partStructure={elementStructure}
            key={elementStructure.id}
          >
            {elementChildrenElements}
          </FormPartElement>
        );
      case FormElementType.Section:
        if (
          !elementStructure.elements ||
          elementStructure.elements.length === 0
        ) {
          return <></>;
        }
        return (
          <FormSectionElement
            sectionStructure={elementStructure}
            hierarchyLevel={hierarchyLevel}
            sectionIndex={elementIndex}
            totalSiblings={totalSiblings}
          >
            {elementChildrenElements}
          </FormSectionElement>
        );
      case FormElementType.Question:
        return (
          <FormQuestionElement
            questionStructure={elementStructure}
            hierarchyLevel={hierarchyLevel}
            questionIndex={elementIndex}
          >
            {elementChildrenElements}
          </FormQuestionElement>
        );
      case FormElementType.Text:
        return (
          <FormText
            textStructure={elementStructure}
            hierarchyLevel={hierarchyLevel}
            textIndex={elementIndex}
          >
            {elementChildrenElements}
          </FormText>
        );
      default:
        return <></>;
    }
  }, [
    elementStructure,
    hierarchyLevel,
    elementIndex,
    totalSiblings,
    elementChildrenElements,
  ]);

  return currentElement;
};

export { FormElementWrapper };
